import React, {useEffect, useState} from 'react';
import {Card, Table, Badge, Dropdown} from 'react-bootstrap';
import {
    updateDeliverySettings,
    filterDeliveryList as filterDeliveryAPI,
    getViewDeliveryDetails,
} from '../../../services/OrderService';
import DeliveryDetails from './DeliveryDetails'; // Import the new component

const svg1 = (
    <svg width='20px' height='20px' viewBox='0 0 24 24' version='1.1'>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <rect x='0' y='0' width='24' height='24'></rect>
            <circle fill='#000000' cx='5' cy='12' r='2'></circle>
            <circle fill='#000000' cx='12' cy='12' r='2'></circle>
            <circle fill='#000000' cx='19' cy='12' r='2'></circle>
        </g>
    </svg>
);

const DeliveryList = props => {
    const {deliveryList, getUpcomingDeliveries} = props;
    const [filteredList, setFilteredList] = useState(deliveryList);
    const [selectedFilter, setSelectedFilter] = useState('All Status');
    const [viewDetails, setViewDetails] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});

    useEffect(() => {
        getUpcomingDeliveries();
    }, [getUpcomingDeliveries]);

    useEffect(() => {
        setFilteredList(deliveryList);
    }, [deliveryList]);

    const updateDeliveryStatus = (ord_id, status) => {
        updateDeliverySettings({ord_id, status})
            .then(() => getUpcomingDeliveries())
            .catch(err => console.error('Error updating status:', err));
    };

    const handleFilterDelivery = (status, filterLabel) => {
        setSelectedFilter(filterLabel);

        if (status === 'all') {
            setFilteredList(deliveryList);
        } else {
            const filtered = deliveryList?.filter(delivery => {
                switch (status) {
                    case 'restaurant_confirmed':
                        return (
                            delivery.status === 'Confirmed' ||
                            delivery.status === 'restaurant_confirmed'
                        );
                    case 'restaurant_cancelled':
                        return (
                            delivery.status === 'Cancelled' ||
                            delivery.status === 'restaurant_cancelled'
                        );
                    case 'pending':
                        return (
                            delivery.status === 'Pending' ||
                            delivery.status === 'restaurant_rejected'
                        );
                    case 'order_completed':
                        return (
                            delivery.status === 'Completed' ||
                            delivery.status === 'Order Completed'
                        );
                         case 'driver_picked':
                        return (
                            delivery.status === 'Driver Picked' ||
                            delivery.status === 'driver_picked'
                        );
                    case 'delivered':
                        return (
                            delivery.status === 'Delivered' ||
                            delivery.status === 'delivered'
                        );    

                    default:
                        return true;
                }
            });
            setFilteredList(filtered);

            filterDeliveryAPI(status)
                .then(res => {
                    if (res && res.data) {
                        setFilteredList(res.data);
                    }
                })
                .catch(err =>
                    console.error('Error filtering delivery list:', err)
                );
        }
    };

    const ViewDetails = ord_id => {
        if (expandedRows[ord_id]) {
            setExpandedRows(prev => ({
                ...prev,
                [ord_id]: false,
            }));
            return;
        }

        if (viewDetails[ord_id]) {
            setExpandedRows(prev => ({
                ...prev,
                [ord_id]: true,
            }));
            return;
        }

        setLoadingDetails(prev => ({
            ...prev,
            [ord_id]: true,
        }));

        getViewDeliveryDetails(ord_id)
            .then(res => {
                if (res && res.length > 0) {
                    setViewDetails(prev => ({
                        ...prev,
                        [ord_id]: res[0],
                    }));
                    setExpandedRows(prev => ({
                        ...prev,
                        [ord_id]: true,
                    }));
                } else {
                    console.warn('No data received for order:', ord_id);
                    setExpandedRows(prev => ({
                        ...prev,
                        [ord_id]: true,
                    }));
                }
            })
            .catch(err => {
                console.error('Error getting delivery details:', err);
                setExpandedRows(prev => ({
                    ...prev,
                    [ord_id]: true,
                }));
            })
            .finally(() => {
                setLoadingDetails(prev => ({
                    ...prev,
                    [ord_id]: false,
                }));
            });
    };

    const closeDetails = ord_id => {
        setExpandedRows(prev => ({
            ...prev,
            [ord_id]: false,
        }));
    };

    return (
        <>
            <div className='d-sm-flex mb-lg-4 mb-2'>
                <Dropdown className='dropdown mb-2 ml-auto mr-3'>
                    <Dropdown.Toggle
                        to='#'
                        className='i-false btn btn-primary btn-rounded light'
                        data-toggle='dropdown'
                        aria-expanded='false'
                    >
                        <i className='las la-bolt scale5 mr-3' />
                        {selectedFilter}
                        <i className='las la-angle-down ml-3' />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='dropdown-menu dropdown-menu-center'>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterDelivery('all', 'All Status')
                            }
                        >
                            <span className='text-primary'>All Status</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterDelivery(
                                    'restaurant_confirmed',
                                    'Booking Confirmed'
                                )
                            }
                        >
                            <span className='text-primary'>
                                Booking Confirmed
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterDelivery(
                                    'restaurant_cancelled',
                                    'Booking Cancelled'
                                )
                            }
                        >
                            <span className='text-warning'>
                                Booking Cancelled
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterDelivery(
                                    'pending',
                                    'Booking Pending'
                                )
                            }
                        >
                            <span className='text-error'>Booking Pending</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterDelivery(
                                    'order_completed',
                                    'Order Completed'
                                )
                            }
                        >
                            <span className='text-success'>
                                Order Completed
                            </span>
                        </Dropdown.Item>

                          <Dropdown.Item
                            className='dropdown-item'
                            onClick={() => handleFilterDelivery('driver_picked','Driver Picked')}
                        >
                            <span className='text-primary'>Driver Picked</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() => handleFilterDelivery('delivered','Delivered')}
                        >
                            <span className='text-primary'>Delivered</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Card>
                <Card.Header>
                    <Card.Title>Live Delivery Orders</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table>
                        <thead>
                            <tr>
                                <th>
                                    <strong>DELIVERY NO.</strong>
                                </th>
                                <th>
                                    <strong>DATE</strong>
                                </th>
                                <th>
                                    <strong>SLOT</strong>
                                </th>
                                <th>
                                    <strong>CUSTOMER</strong>
                                </th>
                                <th>
                                    <strong>AMOUNT</strong>
                                </th>
                                <th>
                                    <strong>STATUS</strong>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList ? (
                                filteredList.length > 0 ? (
                                    filteredList.map(each => (
                                        <React.Fragment key={each.booking_id}>
                                            <tr>
                                                <td>
                                                    <strong>
                                                        {each.booking_id}
                                                    </strong>
                                                </td>
                                                <td>{each.date}</td>
                                                <td>{each.slote}</td>
                                                <td>{each.initiator}</td>
                                                <td>SAR {each.total}</td>
                                                <td>
                                                     <Badge
                                                       variant={
                                                            each.status ===
                                                            'Confirmed'
                                                                ? 'success light'
                                                                : each.status ===
                                                                  'Completed'
                                                                ? 'success light'
                                                                : each.status ===
                                                                  'Pending'
                                                                ? 'warning '
                                                                : each.status ===
                                                                  'Driver Picked'
                                                                ? 'primary '
                                                                : each.status ===
                                                                  'Delivered'
                                                                ? 'success '
                                                                : 'dark text-white '
                                                        }
                                                    >
                                                        {each.status}
                                                    </Badge>

                                                </td>
                                                <td>
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant={
                                                                each.status ===
                                                                'Confirmed'
                                                                    ? 'success'
                                                                    : each.status ===
                                                                      'Completed'
                                                                    ? 'success light'
                                                                    : each.status ===
                                                                      'Pending'
                                                                    ? 'warning '
                                                                    : 'dark text-white '
                                                            }
                                                            className='light sharp i-false'
                                                        >
                                                            {svg1}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu className='dropdown-menu dropdown-menu-right'>
                                                            {each.status?.toLowerCase() ===
                                                                'pending' && (
                                                                <>
                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            updateDeliveryStatus(
                                                                                each.booking_id,
                                                                                'restaurant_confirmed'
                                                                            )
                                                                        }
                                                                        className='dropdown-item'
                                                                    >
                                                                        <i className='las la-check-circle text-success mr-3 scale5' />
                                                                        Confirm
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            updateDeliveryStatus(
                                                                                each.booking_id,
                                                                                'restaurant_cancelled'
                                                                            )
                                                                        }
                                                                        className='dropdown-item'
                                                                    >
                                                                        <i className='las la-times-circle text-danger mr-3 scale5' />
                                                                        Reject
                                                                    </Dropdown.Item>
                                                                </>
                                                            )}

                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    ViewDetails(
                                                                        each.booking_id
                                                                    )
                                                                }
                                                                className='dropdown-item'
                                                            >
                                                                <i className='las la-eye mr-3 scale5' />
                                                                {loadingDetails[
                                                                    each
                                                                        .booking_id
                                                                ]
                                                                    ? 'Loading...'
                                                                    : 'View Details'}
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                            {expandedRows[each.booking_id] && (
                                                <DeliveryDetails
                                                    orderDetails={
                                                        viewDetails[
                                                            each.booking_id
                                                        ]
                                                    }
                                                    isLoading={
                                                        loadingDetails[
                                                            each.booking_id
                                                        ]
                                                    }
                                                    onClose={closeDetails}
                                                    bookingId={each.booking_id}
                                                />
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan='7' className='text-center'>
                                            No deliveries found
                                        </td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td colSpan='7'>
                                        <div id='preloader-inner'>
                                            <div className='sk-three-bounce-inner'>
                                                <div className='sk-child sk-bounce1'></div>
                                                <div className='sk-child sk-bounce2'></div>
                                                <div className='sk-child sk-bounce3'></div>
                                                <div id='preloader-inner-bg'></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
};

export default DeliveryList;
